import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DepartmentState, Department } from './types';

// Initial state
const initialState: DepartmentState = {
  selectedDepartment: null
};

const departmentManagementSlice = createSlice({
  name: 'departmentManagement',
  initialState,
  reducers: {
    setSelectedDepartment(state, action: PayloadAction<Department | null>) {
      state.selectedDepartment = action.payload;
    }
  }
});

export const { setSelectedDepartment } = departmentManagementSlice.actions;

export default departmentManagementSlice.reducer;
